export const federatedIdentityProvider = "cognito-identity.amazonaws.com";
